var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEnergy = function SvgEnergy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "energy_svg__svg-icon"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#energy_svg__a)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.966 15.016v1.708h-3.933v-1.708c0-.348-.077-.674-.224-.965a2.12 2.12 0 0 0-.646-.753A4.77 4.77 0 0 1 7.212 9.44c0-1.322.536-2.518 1.403-3.385A4.767 4.767 0 0 1 12 4.652c1.322 0 2.519.537 3.385 1.403a4.771 4.771 0 0 1 1.402 3.385 4.77 4.77 0 0 1-1.951 3.858 2.12 2.12 0 0 0-.646.753c-.148.29-.224.617-.224.965Zm.147 2.218H12l-2.113.008A2.121 2.121 0 0 0 12 19.348c1.16 0 2.113-.954 2.113-2.114ZM11.726 9.73l-1.098 2.632 2.853-3.127h-1.7l1.444-2.063H11.37l-.85 2.502 1.207.056Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "energy_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h24v24H0z"
  })))));
};
export { SvgEnergy as ReactComponent };